import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { mainAction } from "../../Redux/Actions";
import { DecodeString, EncodeString, GetCookieV2, RemoveAccents } from "../../Utils";
import { Select, Space } from "antd";

const SelectWarehouseComp = React.forwardRef(
  ({
    onSelected = () => { },
    onActive = 0,
    Disabled = false,
    formType = "report"
  }, ref) => {
    const dispatch = useDispatch();

    const dtLogin = useMemo(() => GetCookieV2("All"), []);
    const Customer = dtLogin?.Active;

    const [data, setData] = useState([]);
    const [valueS, setValueS] = useState(null);
    const [isInitialized, setIsInitialized] = useState(false);

    // Hàm cập nhật localStorage
    const updateLocalStorage = useCallback((selectedElement) => {
      if (!selectedElement) return;

      let objectCookies = localStorage.getItem("clgv2");
      let obj = objectCookies ? JSON.parse(DecodeString(objectCookies)) : {};
      obj.Active = selectedElement;
      let encodedData = EncodeString(JSON.stringify(obj));
      localStorage.setItem("clgv2", encodedData);
    }, []);

    const onSelecteItem = useCallback((item, key = 0) => {
      let selectedData = null;

      if (key === 0) {
        selectedData = data?.find((p) => p.value === item) || null;
        setValueS(item);
      } else {
        selectedData = item;
        setValueS(item.value);
      }

      if (selectedData) {
        updateLocalStorage(selectedData.element);
        onSelected(selectedData);
      }
    }, [data, updateLocalStorage, onSelected]);

    const APIC_spCustomer_ByGroup = useCallback(async () => {
      const pr = {
        CustomerGroupId: dtLogin.IsLoginByGroup === 1 ? dtLogin.Group.Id : 0,
        CustomerId: dtLogin.IsLoginByGroup === 1 ? 0 : Customer?.CustomerID,
      };
      const params = {
        Json: JSON.stringify(pr),
        func: "APIC_spCustomer_ByGroup",
      };
      
      const list = await mainAction.API_spCallServer(params, dispatch);

      let dataOptions = [];
      if (dtLogin?.Group?.Id !== 0 && dtLogin?.Group?.Id !== undefined)
        dataOptions.push({ value: 0, label: formType === "report" ? "Tất cả" : "Vui lòng chọn" });
      
      list.forEach((element) => {
        let option = {
          value: element.CustomerID,
          label: element.CustomerID + " - " + element.CustomerCode + " - " + element.CityName + " - " + element.CustomerName,
          element: element,
        };
        dataOptions.push(option);
      });
      
      setData(dataOptions);
      setIsInitialized(true);

      // Xử lý active sau khi có data - CHỈ LẦN ĐẦU
      if (onActive !== 0 && onActive !== undefined) {
        let dataActive = dataOptions.find((a) => a.value === onActive);
        if (dataActive) {
          setValueS(dataActive.value);
          updateLocalStorage(dataActive.element);
          onSelected(dataActive);
        }
      } else if (dataOptions.length > 1 && formType === "create") {
        setValueS(dataOptions[1].value);
        updateLocalStorage(dataOptions[1].element);
        onSelected(dataOptions[1]);
      } else if (dataOptions.length > 0) {
        setValueS(dataOptions[0].value);
        updateLocalStorage(dataOptions[0].element);
        onSelected(dataOptions[0]);
      }
    }, [dtLogin, Customer, formType, onActive, updateLocalStorage, onSelected, dispatch]);

    // Load data một lần khi mount
    useEffect(() => {
      APIC_spCustomer_ByGroup();
    }, []); // Empty dependency

    // Xử lý khi onActive thay đổi từ bên ngoài - CHỈ SAU KHI ĐÃ KHỞI TẠO
    useEffect(() => {
      if (!isInitialized || !data.length) return;
      
      if (onActive !== undefined && onActive !== 0 && onActive !== valueS) {
        let dataActive = data.find((a) => a.value === onActive);
        if (dataActive) {
          setValueS(dataActive.value);
          updateLocalStorage(dataActive.element);
          onSelected(dataActive);
        }
      }
    }, [onActive]); // CHỈ THEO DÕI onActive

    return (
      <Select
        onChange={e => onSelecteItem(e)}
        style={{ width: "100%" }}
        placeholder="Chọn kho gửi hàng"
        value={valueS}
        options={data}
        optionRender={(option) => (
          <Space>
            <span role="img" aria-label={option.label}>
              {option.label}
            </span>
          </Space>
        )}
        showSearch
        filterOption={(input, option) =>
          RemoveAccents(option.label.toLowerCase()).includes(
            RemoveAccents(input.toLowerCase())
          )
        }
        disabled={Disabled}
        ref={ref}
      />
    );
  }
);

export const SelectWarehouse = React.memo(SelectWarehouseComp);